module.exports = __webpack_public_path__ + "static/img/bg.67a9ff20.png";